import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Loading from 'uI/Loading/Loading';
import BreadCrumb from 'uI/BreadCrumb/BreadCrumb';
import TopSection from './TopSection/TopSection';
import BottomSection from './BottomSection/BottomSection';
import SpecificSection from './SpecificSection/SpecificSection';

import {
  accesCourse,
  courseDetails,
  courseReviews,
  lessonsCourse,
  usersInCourse
} from 'store/product-actions';

import classes from './ProductCourse.module.css';

const ProductCourse = () => {
  const { productType, idProduct } = useParams();
  const [loading, setLoading] = useState(true);
  const [courseData, setCourseData] = useState('');
  const [access, setAccess] = useState('');
  const [loadAccess, setLoadAccess] = useState(false);
  const [lessons, setLessons] = useState({});
  const [reviews, setReviews] = useState({});
  const [users, setUsers] = useState(0);

  useEffect(() => {
    (async () => {
      setCourseData(await courseDetails(idProduct));
    })();
  }, []);

  useEffect(() => {
    if (!loadAccess && courseData.idCourse) {
      (async () => {
        setAccess(await accesCourse(idProduct, courseData.idEmisor));
        setLoadAccess(true);
      })();
    }
  }, [courseData]);

  useEffect(() => {
    if (access === false) {
      (async () => {
        setLessons(await lessonsCourse(idProduct));
        setUsers(await usersInCourse(idProduct));
        setReviews(await courseReviews(idProduct));
        setLoading(false);
      })();
    } else if (access === true) {
      setLoading(false);
    }
  }, [access]);

  return (
    <>
      {!loading ? (
        <>
          <BreadCrumb
            productType={productType}
            productName={courseData.name}
          />
          {!access ? (
            <div className={classes.productContainer}>
              <SpecificSection
                courseData={courseData}
                users={users}
                lessons={lessons}
              />
              <TopSection
                courseData={courseData}
                users={users}
                courseReviews={reviews.averageStars}
              />
              <BottomSection
                courseData={courseData}
                lessons={lessons}
                accessCourse={access}
                reviews={reviews}
              />
            </div>
          ) : (
            <iframe
              src={`${process.env.REACT_APP_API_PATH_MAYAHII_URL}/${courseData.shortEmisor}/course/${courseData.idCourse}`}
              className={classes.iframeContainer}
              frameBorder={0}
            />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default ProductCourse;
